module.exports = __webpack_public_path__ + "img/Iphone_Cam_03-Final-Cupcake.5e06599c.png";